import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  apiError,
  getProblemTypes,
  problemTypeListSuccessful,
  problemTypeAddSuccessful,
  isModelVisible,
  vehicleListSuccessful,
  customerListSuccessful,
  hpNumberListSuccessful,
} from "./problemTypeSlice";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
} from "react-icons/ri";
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
  // postMultipartFormData,
  // putMultipartFormData,
} from "../../../helpers/Helper";

function* getProblemTypesList({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/problemtypes/", params);
    yield put(problemTypeListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddProblemType({ payload }) {
  try {
    // Currently only sending name. Uncomment below for multipart when category/file fields are enabled.
    // const formData = new FormData();
    // formData.append("name", payload.name);
    // formData.append("category", payload.category);
    // if (payload.category_value) {
    //   formData.append("category_value", payload.category_value);
    // }
    // if (payload.file && payload.file.originFileObj) {
    //   formData.append("file", payload.file.originFileObj);
    // }

    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/problemtypes/", { name: payload.name });
      if (response.status === 201) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Problem Type Added Successfully!</p>,
        });
        yield put(getProblemTypes({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: <span className="remix-icon"><RiAlertLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Unable to add Problem Type!</p>,
        });
      }
      yield put(problemTypeAddSuccessful());
    } else {
      const response = yield call(postEdit, "/masters/problemtypes/" + payload.id, { name: payload.name });
      if (response.status === 200) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Problem Type Updated Successfully!</p>,
        });
        yield put(getProblemTypes({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: <span className="remix-icon"><RiAlertLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: <p className="hp-p1-body hp-text-color-black-80">Unable to update Problem Type!</p>,
        });
      }
      yield put(problemTypeAddSuccessful());
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>,
    });
    yield put(apiError(error));
  }
}

function* DeleteProblemType({ payload }) {
  try {
    const response = yield call(postDelete, "/masters/problemtypes/" + payload);
    if (response.status === 204) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <p className="hp-p1-body hp-text-color-black-80">Problem Type deleted!</p>,
      });
      yield put(getProblemTypes({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: <span className="remix-icon"><RiAlertLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: <p className="hp-p1-body hp-text-color-black-80">Unable to delete!</p>,
      });
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <p className="hp-p1-body hp-text-color-black-80">Server side issue!</p>,
    });
    yield put(apiError(error));
  }
}

function* fetchVehicleList({ payload }) {
  try {
    const response = yield call(getParamsList, "/masters/vehicles/", payload);
    yield put(vehicleListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchCustomerList({ payload }) {
  try {
    const response = yield call(getParamsList, "/masters/person/list", {
      ...payload,
      ordering: "-code",
    });
    yield put(customerListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* fetchHpNumberList({ payload }) {
  try {
    // API to be provided later - placeholder endpoint
    const response = yield call(getParamsList, "/sale/finance-ovf/", payload);
    yield put(hpNumberListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchGetProblemTypes() {
  yield takeEvery("problemType/getProblemTypes", getProblemTypesList);
}
export function* watchProblemTypeAdd() {
  yield takeEvery("problemType/problemTypeAdd", AddProblemType);
}
export function* watchProblemTypeDelete() {
  yield takeEvery("problemType/problemTypeDelete", DeleteProblemType);
}
export function* watchGetVehicleList() {
  yield takeEvery("problemType/getVehicleList", fetchVehicleList);
}
export function* watchGetCustomerList() {
  yield takeEvery("problemType/getCustomerList", fetchCustomerList);
}
export function* watchGetHpNumberList() {
  yield takeEvery("problemType/getHpNumberList", fetchHpNumberList);
}

function* ProblemTypeSaga() {
  yield all([
    fork(watchGetProblemTypes),
    fork(watchProblemTypeAdd),
    fork(watchProblemTypeDelete),
    fork(watchGetVehicleList),
    fork(watchGetCustomerList),
    fork(watchGetHpNumberList),
  ]);
}

export default ProblemTypeSaga;
